import { render } from "./EmailConfirmationPage.vue?vue&type=template&id=331828ec&ts=true"
import script from "./EmailConfirmationPage.vue?vue&type=script&lang=ts"
export * from "./EmailConfirmationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__